export default "__VITE_ASSET__DXYGdO22__"